module.exports = __webpack_public_path__ + "static/media/bg-accordion.c008d503.jpg";